
import React from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import './styles/Dashboard.css'; // Importer des styles spécifiques pour le Dashboard

const DashboardLayout = ({ children }) => {
  return (
    <div className="dashboard-container">
      <Sidebar />
      <div className="dashboard-content">
        <Header />
        <div className="dashboard-main">
          {children}
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
